/**
 * @generated SignedSource<<cd8ab25fa5a13d57e456ff6013b6e56e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type HideSageSyncAnalysisIssuesInput = {
  ids?: ReadonlyArray<string | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type hideSageSyncAnalysisIssuesMutation$variables = {
  input: HideSageSyncAnalysisIssuesInput;
};
export type hideSageSyncAnalysisIssuesMutation$data = {
  readonly hideSageSyncAnalysisIssues: {
    readonly ids: ReadonlyArray<string | null> | null;
  } | null;
};
export type hideSageSyncAnalysisIssuesMutation = {
  variables: hideSageSyncAnalysisIssuesMutation$variables;
  response: hideSageSyncAnalysisIssuesMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "HideSageSyncAnalysisIssuesPayload",
    "kind": "LinkedField",
    "name": "hideSageSyncAnalysisIssues",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ids",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "hideSageSyncAnalysisIssuesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "hideSageSyncAnalysisIssuesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0297750da48f13f5e047cd8e291fd8f9",
    "id": null,
    "metadata": {},
    "name": "hideSageSyncAnalysisIssuesMutation",
    "operationKind": "mutation",
    "text": "mutation hideSageSyncAnalysisIssuesMutation(\n  $input: HideSageSyncAnalysisIssuesInput!\n) {\n  hideSageSyncAnalysisIssues(input: $input) {\n    ids\n  }\n}\n"
  }
};
})();

(node as any).hash = "58d9258aa946517db6b28ac02a1c5d25";

export default node;
